import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin } from 'lucide-react';
import logoImage from '../../assets/images/logo-lingland.png';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();
  const emailAddress = "biuro@lingland.pl";

  return (
    <footer className="app-footer">
      <div className="footer-container">
        <div className="footer-section footer-logo-section">
          <Link to="/">
            {/* Ciemne logo będzie teraz OK na jasnym tle */}
            <img src={logoImage} alt="Lingland Logo" className="footer-logo-img" />
          </Link>
          <p className="footer-tagline">Nowoczesne biuro tłumaczeń</p>
        </div>

        <div className="footer-section footer-links">
           <h4>Menu</h4>
           <ul>
             <li><Link to="/">Strona Główna</Link></li>
             <li><Link to="/uslugi">Usługi</Link></li>
             <li><Link to="/cennik">Cennik</Link></li>
             <li><Link to="/blog">Blog</Link></li> {/* <- Dodany link */}
             <li><Link to="/kontakt">Kontakt</Link></li>
           </ul>
         </div>

        <div className="footer-section footer-legal">
          <h4>Informacje</h4>
          <ul>
            <li><Link to="/polityka-prywatnosci">Polityka prywatności</Link></li>
            <li><Link to="/regulamin">Regulamin (RODO)</Link></li>
            <li>
              <a href={`mailto:${emailAddress}`}>{emailAddress}</a>
            </li>
          </ul>
        </div>

        <div className="footer-section footer-social">
          <h4>Obserwuj nas</h4>
          <div className="social-icons">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <Instagram size={24} strokeWidth={1.5}/>
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <Linkedin size={24} strokeWidth={1.5}/>
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {currentYear} Lingland. Wszelkie prawa zastrzeżone.</p>
      </div>
    </footer>
  );
}

export default Footer;